import { observer } from '@legendapp/state/react';

import { state$ } from "../../../state";

import "./footer.scss";

export const Footer = observer(() => {
  const isFullWidthState = state$.settings.isFullWidthState.get();
  return (
    <footer className="app-footer">
      <div className={`animated-max-width app-footer--wrapper ${!isFullWidthState ? 'container' : 'container-fluid'}`}>
        <div className="row">
          <div className="col">
            <footer className={`login-footer app-footer__container`}>
              <p className='login-footer__item login-footer__item--copyright'>
                © {
                  new Date().getFullYear()
                } CMS Cameron McKenna Nabaro Olswang LLP
              </p>
            </footer>
          </div>
        </div>
      </div>
    </footer>
  )
})
